import { render, staticRenderFns } from "./SwProductsByDemand.vue?vue&type=template&id=5499bd2e&scoped=true"
import script from "./SwProductsByDemand.vue?vue&type=script&lang=js"
export * from "./SwProductsByDemand.vue?vue&type=script&lang=js"
import style0 from "./SwProductsByDemand.vue?vue&type=style&index=0&id=5499bd2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499bd2e",
  null
  
)

export default component.exports